import parseDate from './parse-date.js';

/**
 * @func formatDateEST
 * @param {date} value  - date to be formatted (accepts date string, ISO string, or date object)
 * @param {object} options - formatting options accepted by toLocaleString. defaults to
 * day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  month: '2-digit',
  year: 'numeric',
 * @param {string} nullPlaceholder - to be returned if date is invalid. defaults to empty string
 * @return {string}
 * @desc Formats a date in EST time
 * ```js
 * formatDateEST ('2020-01-01T17:00:00Z');
 * // returns '01/01/2020 12:00 PM EST'
 *
 * formatDateEST('2020-01-11T17:00:00Z', { options: { day: '2-digit', month: 'long' } })
 * // returns 'January 11 EST'
 * ```
 * @memberof module:Date
 * @instance
 */
function formatDateEST(date, { options = defaultOptions, nullPlaceholder = '' } = {}) {
    const parsedDate = parseDate(date);
    if (!parsedDate)
        return nullPlaceholder;
    const localeOptions = Object.assign(Object.assign({}, options), { timeZone: 'America/New_York' });
    delete localeOptions.timeStyle;
    const [day, time] = parsedDate
        .toLocaleString('en-US', localeOptions)
        .split(',');
    const optionKeys = Object.keys(options);
    if (optionKeys.includes('hour') || optionKeys.includes('timeStyle'))
        return `${day}${time} EST`;
    return `${day} EST`;
}
const defaultOptions = {
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    month: '2-digit',
    year: 'numeric',
};

export { formatDateEST as default };
